import { render, staticRenderFns } from "./DashboardEventRow.vue?vue&type=template&id=bc4296e8&"
import script from "./DashboardEventRow.vue?vue&type=script&lang=js&"
export * from "./DashboardEventRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports